/* Munchkin Mall theme — vanilla JS, no dependencies. */
(function () {
  'use strict';

  var mm = window.mm || {};
  var routes = mm.routes || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var desktop = window.matchMedia('(min-width: 1024px)');

  /* ---------- Money formatting (mirrors Shopify money formats) ---------- */
  function formatNumber(value, decimals, thousands, decimal) {
    var parts = value.toFixed(decimals).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }
  function money(cents) {
    var format = mm.moneyFormat || '${{amount}}';
    var value = cents / 100;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      switch (name) {
        case 'amount_no_decimals': return formatNumber(value, 0, ',', '.');
        case 'amount_with_comma_separator': return formatNumber(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return formatNumber(value, 0, '.', ',');
        case 'amount_no_decimals_with_space_separator': return formatNumber(value, 0, ' ', '.');
        case 'amount_with_apostrophe_separator': return formatNumber(value, 2, "'", '.');
        default: return formatNumber(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Layers: mobile menu, search, cart drawer ---------- */
  var lastFocus = null;
  function openLayer(layer) {
    if (!layer) return;
    lastFocus = document.activeElement;
    layer.hidden = false;
    // force reflow so the transition runs
    void layer.offsetWidth;
    layer.classList.add('is-open');
    document.documentElement.classList.add('mm-lock');
    var target = $('[data-search-input]', layer) || $('.mm-layer__panel', layer);
    if (target) {
      if (!target.hasAttribute('tabindex') && target.tagName !== 'INPUT') target.setAttribute('tabindex', '-1');
      window.setTimeout(function () { target.focus({ preventScroll: true }); }, 60);
    }
  }
  function closeLayer(layer) {
    if (!layer || layer.hidden) return;
    layer.classList.remove('is-open');
    window.setTimeout(function () {
      if (!layer.classList.contains('is-open')) layer.hidden = true;
      if (!$('.mm-layer.is-open') && !$('.mm-listing__side.is-open')) document.documentElement.classList.remove('mm-lock');
    }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function closeAllLayers() {
    $$('.mm-layer.is-open').forEach(closeLayer);
    closeFilters();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-open]');
    if (opener) {
      var layer = document.getElementById(opener.getAttribute('data-open'));
      if (layer) {
        event.preventDefault();
        closeAllLayers();
        openLayer(layer);
        return;
      }
    }
    var closer = event.target.closest('[data-close]');
    if (closer) {
      var host = closer.closest('[data-layer]');
      if (host) closeLayer(host);
      return;
    }
    // Links inside layers should close them (same-page anchors)
    var link = event.target.closest('.mm-layer a[href^="#"]');
    if (link) closeAllLayers();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllLayers();
      $$('[data-mega].is-open').forEach(closeMega);
    }
    if (event.key === 'Tab') {
      var open = $('.mm-layer.is-open .mm-layer__panel');
      if (!open) return;
      var focusable = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', open)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Header: scroll state and mega menu ---------- */
  var header = $('[data-header]');
  function onScroll() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 12); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var closeTimer;
  function openMega(item) {
    window.clearTimeout(closeTimer);
    $$('[data-mega].is-open').forEach(function (other) { if (other !== item) closeMega(other); });
    item.classList.add('is-open');
    var toggle = $('[data-mega-toggle]', item);
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (header) header.classList.add('is-mega-open');
  }
  function closeMega(item) {
    item.classList.remove('is-open');
    var toggle = $('[data-mega-toggle]', item);
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (header && !$('[data-mega].is-open')) header.classList.remove('is-mega-open');
  }
  function initMega() {
    $$('[data-mega]').forEach(function (item) {
      if (item.dataset.mmInit) return;
      item.dataset.mmInit = '1';
      item.addEventListener('mouseenter', function () { if (desktop.matches) openMega(item); });
      item.addEventListener('mouseleave', function () {
        if (!desktop.matches) return;
        closeTimer = window.setTimeout(function () { closeMega(item); }, 120);
      });
      item.addEventListener('focusin', function () { if (desktop.matches) openMega(item); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeMega(item);
      });
      var toggle = $('[data-mega-toggle]', item);
      if (toggle) toggle.addEventListener('click', function () {
        if (item.classList.contains('is-open')) closeMega(item); else openMega(item);
      });
      item.addEventListener('click', function (e) { if (e.target.closest('.mm-mega a')) closeMega(item); });
    });
  }

  /* ---------- Cart (AJAX drawer) ---------- */
  function drawerEnabled() { return mm.cartType === 'drawer' && !!document.getElementById('mm-cart-drawer'); }

  function setCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      var grew = Number(el.textContent || 0) < count;
      el.textContent = count;
      el.hidden = count === 0;
      if (grew) {
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      }
    });
  }

  function renderDrawer(html) {
    var panel = $('#mm-cart-drawer [data-cart-panel]');
    if (!panel || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = $('[data-cart-panel]', doc);
    if (!next) return;
    panel.innerHTML = next.innerHTML;
    setCartCount(Number(next.getAttribute('data-item-count') || 0));
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'We could not update your cart. Please try again.');
        return data;
      });
    });
  }

  function showError(el, message) {
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form) {
      var filterForm = event.target.closest('[data-filter-form]');
      if (filterForm) {
        // Keep URLs clean: skip empty price boxes
        $$('input[type="number"]', filterForm).forEach(function (input) { if (input.value === '') input.disabled = true; });
      }
      return;
    }
    if (!drawerEnabled()) return; // fall back to normal form post -> cart page
    if (event.submitter && event.submitter.name === 'return_to') return; // "Buy it now"
    event.preventDefault();

    var idInput = $('[name="id"]', form);
    var qtyInput = $('[name="quantity"]', form);
    if (!idInput || !idInput.value) return;
    var button = $('[type="submit"]:not([name])', form);
    var errorEl = $('[data-form-error]', form);
    showError(errorEl, '');
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }

    cartRequest(routes.cartAdd + '.js', {
      items: [{ id: Number(idInput.value), quantity: Math.max(1, Number(qtyInput && qtyInput.value) || 1) }],
      sections: 'cart-drawer'
    }).then(function (data) {
      renderDrawer(data.sections && data.sections['cart-drawer']);
      closeAllLayers();
      openLayer(document.getElementById('mm-cart-drawer'));
    }).catch(function (err) {
      showError(errorEl, err.message);
      if (!errorEl) window.alert(err.message);
    }).then(function () {
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
    });
  });

  document.addEventListener('click', function (event) {
    var drawer = event.target.closest('#mm-cart-drawer');
    if (!drawer) return;
    var stepBtn = event.target.closest('[data-qty-change]');
    var removeBtn = event.target.closest('[data-remove]');
    if (!stepBtn && !removeBtn) return;
    var row = event.target.closest('[data-line]');
    if (!row) return;
    var qtyEl = $('.mm-qty span', row);
    var current = Number(qtyEl ? qtyEl.textContent : 1) || 1;
    var quantity = removeBtn ? 0 : Math.max(0, current + Number(stepBtn.getAttribute('data-qty-change')));
    row.classList.add('is-busy');
    cartRequest(routes.cartChange + '.js', {
      line: Number(row.getAttribute('data-line')),
      quantity: quantity,
      sections: 'cart-drawer'
    }).then(function (data) {
      renderDrawer(data.sections && data.sections['cart-drawer']);
    }).catch(function (err) {
      row.classList.remove('is-busy');
      var errorEl = $('[data-cart-error]', drawer);
      if (errorEl) showError(errorEl, err.message);
    });
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    if (root.dataset.mmInit) return;
    root.dataset.mmInit = '1';

    var dataEl = $('script[data-variants]', root);
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var form = $('[data-product-form]', root);
    var idInput = form && $('[data-variant-id]', form);
    var qtyInput = form && $('[data-qty-input]', form);
    var addButton = form && $('[data-add-button]', form);
    var addLabel = form && $('[data-add-label]', form);
    var buyNow = form && $('[data-buy-now]', form);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare-price]', root);
    var saveEl = $('[data-save]', root);
    var stockEl = $('[data-stock]', root);
    var stockText = stockEl && $('[data-stock-text]', stockEl);
    var optionInputs = $$('[data-option-input]', root);
    var current = null;

    /* Gallery */
    var gallery = $('[data-gallery]', root);
    var slides = gallery ? $$('[data-slide]', gallery) : [];
    var thumbs = gallery ? $$('[data-thumb]', gallery) : [];
    var counter = gallery && $('[data-gallery-index]', gallery);
    var stage = gallery && $('[data-stage]', gallery);
    var index = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));

    function showSlide(next) {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        if (i === index) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = index + 1;
      resetZoom();
    }
    function showMedia(id) {
      if (id === null || id === undefined) return;
      var i = slides.findIndex(function (s) { return s.getAttribute('data-slide') === String(id); });
      if (i >= 0) showSlide(i);
    }
    function activeImage() { var s = slides[index]; return s && $('img', s); }
    function resetZoom() { slides.forEach(function (s) { var img = $('img', s); if (img) img.style.transform = ''; }); }

    if (gallery) {
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showSlide(i); }); });
      var prev = $('[data-gallery-prev]', gallery);
      var next = $('[data-gallery-next]', gallery);
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); showSlide(index - 1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); showSlide(index + 1); });
      if (stage) {
        var hoverOk = window.matchMedia('(hover: hover) and (pointer: fine)');
        stage.addEventListener('mousemove', function (e) {
          if (!hoverOk.matches) return;
          var img = activeImage();
          if (!img) return;
          var rect = stage.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - rect.left) / rect.width * 100) + '% ' + ((e.clientY - rect.top) / rect.height * 100) + '%';
          img.style.transform = 'scale(1.85)';
        });
        stage.addEventListener('mouseleave', resetZoom);
        var startX = null;
        stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (startX === null || slides.length < 2) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) showSlide(index + (dx < 0 ? 1 : -1));
          startX = null;
        });
      }
    }

    /* Quantity */
    function clampQty() {
      if (!qtyInput) return;
      var max = current && current.tracked ? Math.max(1, current.stock) : 99;
      var value = Math.max(1, Math.min(max, parseInt(qtyInput.value, 10) || 1));
      qtyInput.value = value;
      qtyInput.max = max;
    }
    if (form) {
      $$('[data-qty-step]', form).forEach(function (btn) {
        btn.addEventListener('click', function () {
          qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + Number(btn.getAttribute('data-qty-step'));
          clampQty();
        });
      });
      if (qtyInput) qtyInput.addEventListener('change', clampQty);
    }

    /* Variants */
    function selection() {
      var values = [];
      optionInputs.forEach(function (input) {
        if (input.checked) values[Number(input.getAttribute('data-option-input'))] = input.value;
      });
      return values;
    }
    function findVariant(values) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      }) || null;
    }
    function updateOptionStates(values) {
      optionInputs.forEach(function (input) {
        var idx = Number(input.getAttribute('data-option-input'));
        var candidate = values.slice();
        candidate[idx] = input.value;
        var match = findVariant(candidate);
        var label = input.closest('.mm-choice');
        if (label) label.classList.toggle('is-soldout', !match || !match.available);
      });
      $$('[data-option]', root).forEach(function (fieldset) {
        var idx = Number(fieldset.getAttribute('data-option'));
        var out = $('[data-option-value]', fieldset);
        if (out) out.textContent = values[idx] || '';
      });
    }
    function render(variant) {
      current = variant;
      var available = !!(variant && variant.available);
      if (idInput && variant) idInput.value = variant.id;
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = !variant ? 'Unavailable' : (available ? 'Add to cart' : 'Sold out');
      if (buyNow) buyNow.hidden = !available;
      if (variant) {
        if (priceEl) priceEl.textContent = variant.price_formatted || money(variant.price);
        var onSale = variant.compare_at_price > variant.price;
        if (compareEl) { compareEl.hidden = !onSale; compareEl.textContent = variant.compare_at_formatted || money(variant.compare_at_price); }
        if (saveEl) {
          saveEl.hidden = !onSale;
          if (onSale) saveEl.textContent = 'Save ' + Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) + '%';
        }
        if (stockEl) {
          var state = 'ok';
          var text = 'In stock';
          if (!available) { state = 'out'; text = 'Sold out'; }
          else if (variant.tracked && variant.stock <= 8) { state = 'low'; text = 'Only ' + variant.stock + ' left'; }
          stockEl.setAttribute('data-state', state);
          if (stockText) stockText.textContent = text;
        }
        showMedia(variant.media_id);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', url);
        } catch (e) { /* ignore */ }
      } else {
        if (stockEl) { stockEl.setAttribute('data-state', 'out'); if (stockText) stockText.textContent = 'This combination is unavailable'; }
      }
      clampQty();
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var values = selection();
        updateOptionStates(values);
        render(findVariant(values));
      });
    });

    var initialValues = selection();
    if (optionInputs.length) updateOptionStates(initialValues);
    current = optionInputs.length ? findVariant(initialValues) : (variants[0] || null);
    clampQty();
  }

  /* ---------- Collection / search filters ---------- */
  function closeFilters() {
    $$('.mm-listing__side.is-open').forEach(function (panel) { panel.classList.remove('is-open'); });
    if (!$('.mm-layer.is-open')) document.documentElement.classList.remove('mm-lock');
  }
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-open-filters]')) {
      var panel = $('[data-filters-panel]');
      if (panel) { panel.classList.add('is-open'); document.documentElement.classList.add('mm-lock'); }
    } else if (event.target.closest('[data-close-filters]')) {
      closeFilters();
    }
  });
  var filterTimer;
  document.addEventListener('change', function (event) {
    var form = event.target.closest('[data-filter-form]');
    if (!form) return;
    var isSort = event.target.hasAttribute('data-auto-submit');
    var inPanel = event.target.closest('[data-filters-panel]');
    if (isSort || (inPanel && desktop.matches)) {
      window.clearTimeout(filterTimer);
      filterTimer = window.setTimeout(function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      }, 250);
    }
  });

  window.addEventListener('pageshow', function () {
    $$('[data-filter-form] input[type="number"]:disabled').forEach(function (input) { input.disabled = false; });
  });

  /* ---------- Predictive search ---------- */
  function initSearch() {
    var input = $('[data-search-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results || input.dataset.mmInit) return;
    input.dataset.mmInit = '1';
    var defaultHtml = results.innerHTML;
    var timer;
    var controller;
    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      var term = input.value.trim();
      if (term.length < 2) {
        if (controller) controller.abort();
        results.innerHTML = defaultHtml;
        return;
      }
      timer = window.setTimeout(function () {
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        var url = routes.predictiveSearch + '?q=' + encodeURIComponent(term) +
          '&section_id=predictive-search&resources[type]=product&resources[limit]=6';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (res) { if (!res.ok) throw new Error('search'); return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var section = $('.mm-predictive', doc);
            if (section) results.innerHTML = section.outerHTML;
          })
          .catch(function () { /* aborted or offline: keep current results */ });
      }, 250);
    });
  }

  /* ---------- Scroll reveal ---------- */
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }) : null;
  function initReveal(scope) {
    $$('[data-reveal]:not(.is-visible)', scope).forEach(function (el, i) {
      if (!observer) { el.classList.add('is-visible'); return; }
      el.style.transitionDelay = ((i % 4) * 80) + 'ms';
      observer.observe(el);
    });
  }

  /* ---------- Boot + theme editor support ---------- */
  function init(scope) {
    initMega();
    initSearch();
    initReveal(scope || document);
    $$('[data-product]', scope || document).forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var layer = e.target.querySelector('[data-layer]');
    if (layer && layer.id === 'mm-cart-drawer') openLayer(layer);
  });
})();
